import { getRequest, type IValidatedResponse } from '../../httpClient';
import type { IGetMyBookmarksV1Request } from './get-my-bookmarks-v1-request';
import {
  getMyBookmarksV1ResponseSchema,
  type IGetMyBookmarksV1Response,
} from './get-my-bookmarks-v1-response';

export async function getMyBookmarksV1Api(
  params?: IGetMyBookmarksV1Request,
): Promise<IValidatedResponse<IGetMyBookmarksV1Response>> {
  const query = new URLSearchParams();
  if (params?.cursor) {
    query.set('cursor', params.cursor);
  }
  if (params?.limit) {
    query.set('limit', String(params.limit));
  }
  const qs = query.toString();

  return getRequest<IGetMyBookmarksV1Response>({
    path: qs ? `/bookmarks/v1?${qs}` : '/bookmarks/v1',
    schema: getMyBookmarksV1ResponseSchema,
  });
}
